module.exports = __webpack_public_path__ + "static/blog41-b1aebc1b76ca08dfc8cd81472de5e1a5.png";